import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { PageTitle } from '@shared/components/page-title/page-title';

@Component({
  selector: 'details-page-layout',
  imports: [MatButtonModule, PageTitle],
  templateUrl: './details-page-layout-component.html',
  styles: ``,
})
export class DetailsPageLayoutComponent {
  title = input.required<string>();
  backLabel = input<string | null>('Back to list');
  gridClass = input('grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 p-5');
  back = output<void>();
}
